import { Component, Input } from '@angular/core';
import { FormGroup } from '@angular/forms';

// text,email,tel,textarea,password,
@Component({
    selector: 'fm-textarea',
    template: `
      <div [formGroup]="form">
        <textarea [placeholder]='field.etiqueta' [formControlName]="field.cod" [id]="field.cod" rows="7" class="form-control"></textarea>
      </div>
    `
})

export class TextAreaComponent {
    @Input() field:any = {};
    @Input() form:FormGroup;
    get isValid() { return this.form.controls[this.field.name].valid; }
    get isDirty() { return this.form.controls[this.field.name].dirty; }

    constructor() {

    }
}
